import * as yup from 'yup'

import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const equalsSibling = {
  name: 'equalsSibling',
  schemaType: STRING_SCHEMA_TYPE,
  method(field, message = 'Os valores devem ser iguais.') {
    return this.oneOf([yup.ref(field), null], message)
  },
}

export default equalsSibling
